export default __webpack_public_path__ + "static/media/simran.be78e0ee.jpeg";